import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";

export default function Psicologia() {
  return (
    <div>
      <NavBar user={{ role: "psicologa" }} />
      <main style={{ padding: "1rem" }}>
        <Outlet /> {/* 👈 Aquí se cargará PsicologiaHome, Pacientes, Calendario, etc */}
      </main>
    </div>
  );
}
